export const letters: string[] = "abcdefghijklmnopqrstuvwxyz0123456789'$%-".split("");
